import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { AgentGroup } from 'src/app/services/models/agentgroup/agentgroup.model';
import {Response} from 'src/app/services/models/response.model'
import {AgentGroupCreateRequest} from 'src/app/services/models/agentgroup/agentgroup.create.request.model'
import { AgentGroupServiceModel } from './models/agentgroup/agentgroupservice.model';
import { AgentGroupUpdateRequest } from './models/agentgroup/agentgroup.update.request.model';
import { AgentGroupServiceUpdateRequest } from './models/agentgroup/agentgroupservice.update.request.model';

@Injectable()
export class AgentGroupService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.agentgroup;
  }

  getAllAgentGroup(): Observable<Response<AgentGroup[]>> {
    const url = `/GetAllAgentGroup`;
    return this.get(url)
    .map(result => new Response<AgentGroup[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  searchAgentGroup(agentGroupName:string, status?:number): Observable<Response<AgentGroup[]>> {
    agentGroupName = agentGroupName.trim();
    const url = `/SearchAgentGroup?agentGroupName=`+encodeURIComponent(agentGroupName)+'&Status='+status;
    return this.get(url)
    .map(result => new Response<AgentGroup[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getAgentGroupInfo(agentgroupID:number): Observable<Response<AgentGroup>> {
    const url = `/GetAgentGroupInfo/`+agentgroupID;
    return this.get(url)
    .map(result => new Response<AgentGroup>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getAgentGroupServices(agentgroupID:number): Observable<Response<AgentGroupServiceModel[]>> {
    const url = `/getAgentGroupServices/`+agentgroupID;
    return this.get(url)
    .map(result => new Response<AgentGroupServiceModel[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  createAgentGroup(agentgroupDetail: AgentGroupCreateRequest): Observable<Response<AgentGroup>> {
    agentgroupDetail.AgentGroupName = agentgroupDetail.AgentGroupName.trim();
    return this.post(`/CreateAgentGroup`, agentgroupDetail, {})
    .map(result => new Response<AgentGroup>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  updateAgentGroup(agentgroupDetail: AgentGroupUpdateRequest): Observable<Response<AgentGroup>> {
    agentgroupDetail.AgentGroupName = agentgroupDetail.AgentGroupName.trim();
    return this.post(`/UpdateAgentGroup`, agentgroupDetail, {})    
    .map(result => new Response<AgentGroup>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  updateAgentGroupService(agentgroupDetail: AgentGroupServiceUpdateRequest): Observable<Response<AgentGroup>> {
    return this.post(`/UpdateAgentGroupService`, agentgroupDetail, {})    
    .map(result => new Response<AgentGroup>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}